import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import Sidebar from './Sidebar';
import UserMessages from './UserMessages';
import { User } from '../data/mockData';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  user: User;
}

const Layout: React.FC<LayoutProps> = ({ children, user }) => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="layout">
      {/* Header */}
      <header className="layout-header">
        <div className="header-left">
          <button
            type="button"
            className="header-menu-button"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open menu"
          >
            <span className="material-icons" style={{ fontSize: 24 }}>menu</span>
          </button>
          <Logo size="medium" variant="white" showText={false} />
        </div>
        <div className="header-right">
          <UserMessages />
          <div className="user-menu" onClick={handleLogout}>
            <span className="user-name">Log out</span>
          </div>
        </div>
      </header>

      <div className="layout-content">
        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* Main Content */}
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
